import { SystemSolutionsPage } from 'src/pages'

const SystemSolutions = () => {
  return <SystemSolutionsPage />
}

export default SystemSolutions
